import { FilterButtonItem } from '../types';

export function filterButtonItems<T>(
    items: FilterButtonItem<T>[],
    showMoreLimit?: number,
): FilterButtonItem<T>[] {
    if (!showMoreLimit) return items;

    if (showMoreLimit > 1) {
        return items.slice(0, showMoreLimit);
    }

    return items;
}
